import React, { useState } from "react";
import { ChevronDown, ChevronUp, FileText } from "lucide-react";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString() : "—");

const Row = ({ label, ok, okText, noText, version, at, wording, testId, notRequired }) => {
  const [open, setOpen] = useState(false);
  const color = notRequired ? "text-[#B9C8D5]" : ok ? "text-emerald-300" : "text-rose-300";
  return (
    <div className="py-2 border-b border-[#FFD166]/10 last:border-0" data-testid={testId}>
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-[#F6F1E4] text-xs font-medium">{label}</div>
          <div className={`text-xs ${color}`} data-testid={`${testId}-status`}>
            {notRequired ? "Not required for this order" : ok ? `✓ ${okText}` : `✗ ${noText}`}
          </div>
          {!notRequired && (version || at) && (
            <div className="text-[10px] text-[#B9C8D5]">
              {version && <>Version: <span className="text-[#F6F1E4]">{version}</span> · </>}Accepted at: <span className="text-[#F6F1E4]">{fmt(at)}</span>
            </div>
          )}
        </div>
        {wording && !notRequired && (
          <button type="button" onClick={() => setOpen((o) => !o)} className="text-[10px] text-[#FFD166] inline-flex items-center gap-1 shrink-0" data-testid={`${testId}-view`}>
            <FileText className="w-3 h-3" /> {open ? "Hide" : "View"} wording {open ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
          </button>
        )}
      </div>
      {open && wording && (
        <div className="mt-2 text-[11px] text-[#E4E9EF] whitespace-pre-line bg-black/30 border border-[#FFD166]/15 rounded-lg p-3 max-h-56 overflow-y-auto" data-testid={`${testId}-wording`}>
          {wording}
        </div>
      )}
    </div>
  );
};

export const AgreementsPanel = ({ r }) => {
  const rec = r.acceptance_record;
  const sleep = rec?.sleep_acknowledgment;
  const mobility = rec?.mobility_acknowledgment;
  const smsOn = rec ? !!rec.sms_consent?.opted_in : !!r.sms_opted_in;
  return (
    <div className="mt-4 rounded-lg border border-[#FFD166]/15 bg-black/25 p-3" data-testid="res-agreements">
      <div className="eyebrow mb-1">Agreements &amp; Acknowledgments</div>
      {!rec && <div className="text-[10px] text-[#F4A93A] mb-1">Legacy order — recorded before versioned acceptance records existed.</div>}
      <Row
        label="Terms of Service" testId="agr-terms"
        ok={rec ? rec.terms?.accepted : !!r.terms_accepted_at} okText="Accepted" noText="Not accepted"
        version={rec?.terms?.version} at={rec?.terms?.accepted_at || r.terms_accepted_at}
        wording={rec?.terms ? `Terms of Service version ${rec.terms.version} — full text at ${rec.terms.text_ref}` : null}
      />
      <Row
        label="SMS Consent" testId="agr-sms"
        ok={smsOn} okText="Opted In" noText="Not Opted In"
        version={rec?.sms_consent?.version || r.sms_consent_version} at={rec?.sms_consent?.accepted_at || r.sms_consent_at}
        wording={rec?.sms_consent?.text}
      />
      <Row
        label="Sleep Equipment Safety Acknowledgment" testId="agr-sleep"
        notRequired={!sleep?.required} ok={!!sleep?.accepted} okText="Accepted" noText="Not accepted"
        version={sleep?.version} at={sleep?.accepted_at} wording={sleep?.text}
      />
      <Row
        label="Mobility Equipment Safety & Assumption-of-Risk Acknowledgment" testId="agr-mobility"
        notRequired={!mobility?.required} ok={!!mobility?.accepted} okText="Accepted" noText="Not accepted"
        version={mobility?.version} at={mobility?.accepted_at} wording={mobility?.text}
      />
      {rec?.audit && (
        <div className="text-[10px] text-[#B9C8D5] mt-2" data-testid="agr-audit">Audit · IP {rec.audit.ip || "—"} · {rec.audit.user_agent ? rec.audit.user_agent.slice(0, 80) : "—"}</div>
      )}
    </div>
  );
};
